module.exports = __webpack_public_path__ + "static/rc-6-efd7337966830db582f6b1203df0e9c1.jpg";